import { Box, Flex, Image, Img, Link, Spinner, Text, useBreakpointValue } from "@chakra-ui/react";
import { useState } from "react";
import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from "react-icons/md";
import Slider from "react-slick";

import { useLoading } from "@/contexts/LoadingContext";
import { useBannersContents } from "@/hooks/Contents";
import { BannersContent } from "@/types";
import { useIsomorphicLayoutEffect } from "framer-motion";
import Router from "next/router";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

export function CarouselHeaderMobile() {
  const [isLoading, setLoading] = useState<boolean>(true);
  const IsWide = useBreakpointValue({ base: false, lg: true });
  const { setActionIsLoading } = useLoading();
  const [ListCarousel, setListCarousel] = useState<BannersContent[]>([] as BannersContent[]);

  const [BannersResponse, BannersError, BannersLoading] = useBannersContents();

  useIsomorphicLayoutEffect(() => {
    if (BannersResponse && BannersError === null) {
      setListCarousel(BannersResponse?.[0]?.contentsArray);
      // setListCarousel(null);
      setLoading(false);
    }
  }, [BannersResponse]);

  function ArrowProductsPrev(props) {
    const { className, style, onClick } = props;
    return (
      <Flex
        cursor={"pointer"}
        bgColor={"#ffffff26"}
        borderRadius={"50px"}
        justifyContent={"center"}
        alignItems={"center"}
        w={"45px"}
        h={"45px"}
        position={"absolute"}
        left={"15%"}
        top={"45%"}
        zIndex={1}
        onClick={onClick}
      >
        <Img
          h={"15px"}
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-banner.svg"}
        />
      </Flex>
    );
  }

  function ArrowProductsNext(props) {
    const { className, style, onClick } = props;
    return (
      <Flex
        cursor={"pointer"}
        bgColor={"#ffffff26"}
        borderRadius={"50px"}
        justifyContent={"center"}
        alignItems={"center"}
        w={"45px"}
        h={"45px"}
        position={"absolute"}
        right={"15%"}
        top={"45%"}
        onClick={onClick}
      >
        <Img
          h={"15px"}
          src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-banner.svg"}
          transform={"rotate(180deg)"}
        />
      </Flex>
    );
  }

  const settings = {
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 4500,
    adaptiveHeight: false,
    nextArrow: <ArrowProductsNext />,
    prevArrow: <ArrowProductsPrev />
  };

  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Box
      display={["Flex", "none"]}
      flexDir={"column"}
      minH={"175px"}
      mt={!isWideVersion && "70px"}
      mb={"20px"}
      w="auto"
      justifyContent="center"
    >
      {isLoading ? (
        <Flex w="full" h={["100px", "250px"]} alignItems={"center"} justify={"center"}>
          <Spinner
            thickness={"3px"}
            speed="0.65s"
            emptyColor="ll-green.main"
            color="#1e1e1e"
            size={["md", "xl"]}
          />
        </Flex>
      ) : (
        <>
          <Slider {...settings}>
            {ListCarousel?.length > 0
              ? ListCarousel.map((slide, index) => (
                  <Flex key={index}>
                    <Link
                      href={slide.Url}
                      onClickCapture={() => setActionIsLoading(true)}
                      onClick={() => {
                        Router.push(slide.Url);
                      }}
                    >
                      <Flex border="none" mr={"10px"} ml={"10px"}>
                        <Flex
                          marginRight={"-2px"}
                          border="none"
                          w="full"
                          h={["90px", "auto"]}
                          background={slide.BgLeft}
                          justifyContent="center"
                          alignItems="center"
                          display={["none", "flex"]}
                        />
                        <Image
                          borderRadius={"15px"}
                          loading={index > 0 ? "lazy" : "eager"}
                          src={isWideVersion ? slide.Image : slide.MobileImage}
                          alt={"Banner LingLong"}
                          width={["full", "1180px"]}
                          height={["auto", "230px"]}
                          onError={(e) =>
                            (e.currentTarget.src =
                              "https://cdn.pneufree.com.br/LingLong/images/Site/img/local/DefaultBanner.jpg")
                          }
                        />
                        <Flex
                          marginLeft={"-2px"}
                          border="none"
                          w="full"
                          background={slide.BgRight}
                          alignItems="center"
                          display={["none", "flex"]}
                        />
                      </Flex>
                    </Link>
                  </Flex>
                ))
              : null}
            {ListCarousel === null ? (
              <Flex border="none">
                <Flex border="none">
                  <Flex
                    border="none"
                    w="100vw"
                    h={["120px", "auto"]}
                    background={"#106BBA"}
                    justifyContent="center"
                    alignItems="center"
                  />
                  <Image
                    loading="eager"
                    alt={"Default Banner LingLong"}
                    src={
                      "https://cdn.pneufree.com.br/LingLong/images/Site/img/local/DefaultBanner.jpg"
                    }
                  />
                  <Flex border="none" w="100vw" background={"#014B96"} alignItems="center" />
                </Flex>
              </Flex>
            ) : null}
          </Slider>
        </>
      )}
    </Box>
  );
}
